// Checks if it's a youtube link
// All forms can be found here https://gist.github.com/rodrigoborgesdeoliveira/987683cfbfcc8d800192da1e73adc486#file-youtubeurlformats-txt
// reged is from https://stackoverflow.com/a/60190609
function extractFromYoutubeLink(url: string) {
    const regex = new RegExp(/(\/|%3D|v=)([0-9A-z-_]{11})([%#?&]|$)/gm)
    const result = regex.exec(url);
    const videoId = result?.[2];
    return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : null
}

function isImage(url:string) {
    return /^https?:\/\/.+\.(jpg|jpeg|png|webp|avif|gif|svg)(.*)$/.test(url);
}

// return the url of the thumbnail by the target url,
// also can be used to check if we support this target url.
export function extractSupportedThumbnailFromUrl(url: string) {
    if (!url) return null

    if (isImage(url)) {
        return url
    }

    const ytLink = extractFromYoutubeLink(url)
    if (ytLink) return ytLink;

    return null
}